<template>
  <div>
    <publication-list />
  </div>
</template>
<script>
import PublicationList from './components/PublicationList.vue'

export default {
  name: 'publications',
  components: {
    PublicationList,
  },
}
</script>
